import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
// Documentation components removed - now handled by external docs.briefcaseai.org
import { ContactPage } from './pages/ContactPage';

import { TeamPage } from './pages/TeamPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { StagingBanner } from './components/staging-banner';
import { Analytics } from '@vercel/analytics/react';
import './styles/design-tokens.css';

function App() {
  return (
    <Router>
      <div className="App min-h-screen">
        <StagingBanner />
        <Routes>
          <Route path="/" element={<HomePage />} />

          {/* Documentation routes removed - now handled by external docs.briefcaseai.org */}

          <Route path="/contact" element={<ContactPage />} />
          <Route path="/team" element={<TeamPage />} />

<Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Analytics />
      </div>
    </Router>
  );
}

export default App;
